(function(){
  'use strict';

  // Item 2: Hide "You may also like" if no recommendations load
  function hideEmptyRecommendations() {
    var recs = document.querySelectorAll('product-recommendations');
    recs.forEach(function(rec) {
      var performed = rec.getAttribute('data-recommendations-performed');
      var hasProducts = rec.querySelector('.resource-list__item');
      var hasSkeleton = rec.querySelector('.product-recommendations__skeleton-item');
      if ((performed === 'true' && !hasProducts) || (!hasProducts && !hasSkeleton)) {
        rec.classList.add('no-recommendations');
        var section = rec.closest('.shopify-section');
        if (section) section.style.display = 'none';
      }
    });
  }

  // Item 4: Inject trust badges below buy buttons on product pages
  function injectTrustBadges() {
    if (document.querySelector('.supmentinc-trust-badges')) return;
    if (!window.location.pathname.includes('/products/')) return;
    var buyButtons = document.querySelector('.buy-buttons-block');
    if (!buyButtons) return;

    var badges = document.createElement('div');
    badges.className = 'supmentinc-trust-badges';
    badges.innerHTML =
      '<span class="trust-item">Secure Checkout</span>' +
      '<span class="trust-item">Free U.S. Shipping</span>' +
      '<span class="trust-item">30-Day Money-Back Guarantee</span>';
    buyButtons.insertAdjacentElement('afterend', badges);
  }

  // Item 7: Add "You save $X" in cart drawer
  function addCartSavings() {
    var cartDrawer = document.querySelector('cart-drawer, .cart-drawer, [data-cart-drawer]');
    if (!cartDrawer) return;
    if (cartDrawer.querySelector('.supmentinc-cart-savings')) return;

    // Try to find compare-at price elements
    var items = cartDrawer.querySelectorAll('[data-cart-item], .cart-item');
    items.forEach(function(item) {
      var priceEl = item.querySelector('[data-price], .price, .cart-item__price, [data-regular-price]');
      var compareEl = item.querySelector('[data-compare-price], .compare-price, .cart-item__compare-price, [data-compare-at-price]');
      if (!priceEl || !compareEl) return;

      var priceText = priceEl.textContent || priceEl.getAttribute('data-price') || '';
      var compareText = compareEl.textContent || compareEl.getAttribute('data-compare-price') || '';
      var price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      var compare = parseFloat(compareText.replace(/[^0-9.]/g, ''));
      if (!price || !compare || compare <= price) return;

      var savings = compare - price;
      var pct = Math.round((savings / compare) * 100);
      var savingsEl = document.createElement('div');
      savingsEl.className = 'supmentinc-cart-savings';
      savingsEl.textContent = 'You save $' + savings.toFixed(2) + ' (' + pct + '%)';
      priceEl.insertAdjacentElement('afterend', savingsEl);
    });
  }

  // Item 8: Hide Shop Pay installment message for orders under $35
  function hideShopPayInstallments() {
    var shopPayMsgs = document.querySelectorAll('.shop-pay-installments, .shop-pay-installments-message, [data-shop-pay-installments]');
    if (!shopPayMsgs.length) return;

    // Find cart total
    var totalEl = document.querySelector('.cart-drawer .cart-total, .cart-drawer .totals__total, .cart-drawer [data-cart-total]');
    if (!totalEl) return;
    var total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, ''));

    shopPayMsgs.forEach(function(el) {
      if (total < 35) {
        el.classList.add('supmentinc-shop-pay-hidden');
      } else {
        el.classList.remove('supmentinc-shop-pay-hidden');
      }
    });
  }

  // Item 9: Sticky mobile buy bar — Horizon theme already has <sticky-add-to-cart> built in.
  // No custom code needed. The theme's own sticky bar activates on scroll past the buy buttons.

  function runAll() {
    hideEmptyRecommendations();
    injectTrustBadges();
    addCartSavings();
    hideShopPayInstallments();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  // Re-run after dynamic content loads
  setTimeout(runAll, 1500);
  setTimeout(runAll, 3000);
  setTimeout(hideEmptyRecommendations, 5000);

  // Watch for cart drawer changes
  var observer = new MutationObserver(function() {
    addCartSavings();
    hideShopPayInstallments();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();